var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, } from "@angular/core";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PlatformLocation } from '@angular/common';
var CasePracticeAuthorizationListComponent = (function () {
    function CasePracticeAuthorizationListComponent(commonService, apiService, platformLocation, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.platformLocation = platformLocation;
        this.route = route;
        this.router = router;
        this.onGoToNextStep = new EventEmitter();
        this.onSetPracticeIndex = new EventEmitter();
        this.isTencent = false; // 是否腾讯对接
        //进入新能力考核标识
        this.version = 0;
        //学习 metaId
        this.learningPathMetaId = 0;
        this.isOpenClass = 0;
        this.isShowQuestionnaire = false;
        this.isShowApproach = false;
        this.questionnaireInfo = null;
        this.currentIndex = 0;
        this.isCustomLock = false;
        this.approachTheme = {};
        this.stepIndex = 0;
        this.lock = false;
        this.isShowToast = false;
    }
    Object.defineProperty(CasePracticeAuthorizationListComponent.prototype, "showGoToSurveyBtn", {
        get: function () {
            return this.practiceList.every(function (item) {
                return item.status === 2;
            });
        },
        enumerable: true,
        configurable: true
    });
    CasePracticeAuthorizationListComponent.prototype.ngOnInit = function () {
        var _this = this;
        // ---Stephen add 2025-03-07---
        // 添加是否腾讯对接的判断
        this.isTencent = this.commonService.checkAndSetModuleId();
        console.log(this.isTencent, '🐂🐂🐂🐂🐂🐂');
        // -------------------------------------------------------------------
        this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
        localStorage.setItem("moduleId", "3");
        var temp = true;
        this.projectId = localStorage.getItem("projectId");
        var projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
        if (this.projectId && projectmsg) {
            projectmsg.map(function (item) {
                if (item.type == 4 && item.lockType == 1) {
                    _this.lock = item.lock;
                    _this.promptText = "\u80FD\u529B\u8003\u6838\u5C06\u4E8E" + item.promptTime + "\u5F00\u653E\u3002";
                }
            });
        }
        //loadconfig
        this.apiService
            .loadConfig("./assets/config/practiceList.json")
            .subscribe(function (result) {
            _this.practiceList.forEach(function (item, index) {
                if (result[item.title] != null) {
                    item["extends"] = result[item.title];
                }
            });
        });
        this.practiceListInit();
    };
    //初始化情景模拟列表
    CasePracticeAuthorizationListComponent.prototype.practiceListInit = function () {
        var _this = this;
        this.getLearningTour().then(function (result) {
            _this.learningPathMetas = result.learning_path_metas;
        }).then(function () {
            return _this.getLearningPathMetaId(_this.learningPathId).then(function (result) {
                $('#learningPathMetaIdContainer').val(result.data);
                return _this.learningPathMetaId = result.data;
            });
        }).then(function () {
            return _this.getPracticeComment(_this.learningPathId, { learningPathId: _this.learningPathId }).then(function (result) {
                return _this.chuanjie = result.length >= 4 ? result[2].comment : '';
            });
        }).then(function () {
            return _this.commonService.getOnceIno(_this.commonService.getOnceValue(_this.learningPathMetaId, 2)).then(function (result) {
                return _this.finishStatus = result == 1;
            });
        }).then(function () {
            return _this.getOrCreateLearningPath(String(_this.learningPathMetaId)).then(function (result) {
                return _this.learningPath = result;
            });
        }).then(function () {
            return _this.getProgress(_this.learningPathMetaId).then(function (result) {
                //向LMS传递进度
                if (localStorage.getItem("source_env") === "LMS_SCORM") {
                    _this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', result[0].progressList[0].progress, "data");
                }
                return _this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
            });
        }).then(function () {
            return _this.getUserQuestionnaireInfo(_this.learningPathMetaId).then(function (result) {
                return _this.questionnaireInfo = result;
            });
        }).then(function () {
            var temp = true;
            _this.commonService.setCustomLockDate(_this.learningPath, Date());
            _this.learningPathSubItems = _this.learningPath.subItems;
            for (var i = 0; i <= _this.practiceList.length - 1; i++) {
                if (_this.practiceList[i].status != 2) {
                    temp = false;
                }
            }
            _this.finished = temp;
            setTimeout(function () {
                if (_this.finished) {
                    //新能力考核 version == 1 时,有能力考核,出现考核按钮,完成按钮不出现
                    if (_this.version == 1) {
                        $("#surveyBtn").fadeIn(200);
                    }
                    else {
                        $("#nextWrap").show().animate({ bottom: 0 });
                    }
                }
            }, 1000);
        }).then(function () {
            _this.approachTheme.colorSystem = 'dark';
            _this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
            _this.approachTheme.currentIndex = _this.currentIndex - 2;
            _this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
            _this.approachTheme.btnTxt = '开启能力考核';
            _this.isShowQuestionnaire = _this.questionnaireInfo && _this.questionnaireInfo.length === 0 && _this.learningPathSubItems.length === 4 && _this.learningPathSubItems.filter(function (d) { return d.type === 3; })[0].progress === 100 && _this.learningPathSubItems.filter(function (d) { return d.type === 4; })[0].progress !== 100;
        }).then(function () {
            _this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(_this.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': _this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
            _this.isCustomLock = _this.learningPathSubItems.length === 4 && _this.learningPathSubItems[3].isLock ? _this.learningPathSubItems : false;
            _this.isShowApproach = true;
        });
    };
    //获取进度
    CasePracticeAuthorizationListComponent.prototype.getProgress = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
        }).toPromise();
    };
    //获取learningPath
    CasePracticeAuthorizationListComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
    };
    //获取传接
    CasePracticeAuthorizationListComponent.prototype.getPracticeComment = function (learningPathId, data) {
        return this.apiService.ajax({
            type: "get",
            url: "/api/concatenation/" + learningPathId,
            data: data
        }).toPromise();
    };
    //获取learningTour
    CasePracticeAuthorizationListComponent.prototype.getLearningTour = function () {
        return this.apiService.ajax({
            type: "get",
            url: "/sr/learningtournew",
        }).toPromise();
    };
    //获取learningPathMetaId
    CasePracticeAuthorizationListComponent.prototype.getLearningPathMetaId = function (learningPathId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
        }).toPromise();
    };
    //查询用户相应能力满意度
    CasePracticeAuthorizationListComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    CasePracticeAuthorizationListComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            backgroundColor: "white",
        });
    };
    CasePracticeAuthorizationListComponent.prototype.goToNextStep = function (i) {
        $('#exerciseMetaId').val(this.practiceList[i].exerciseMetaId);
        if (this.practiceList[0].status !== 2) {
            this.exerciseMetaId = $('#exerciseMetaId').val();
            this.apiService.learingTime({ learningPathMetaId: $('#learningPathMetaIdContainer').val(), module: "情景模拟", courseUnit: '', type: 1, btnName: this.exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                console.log(result);
            });
            this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
        }
        // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
        this.onSetPracticeIndex.emit(i);
        if (this.practiceList[i].status == 2) {
            var link = [
                "case-practice-report-new",
                this.practiceId,
                this.practiceList[i].id,
                this.learningPathId,
            ];
            if (this.type) {
                this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                this.router.navigate(link);
            }
        }
        else {
            this.toNextStep(this.exerciseMetaId, [701, 702, 703, 704], i).then();
        }
    };
    //进入阶段（情景模拟MetaId，记录OnceTypeId，情景模拟下标）
    CasePracticeAuthorizationListComponent.prototype.toNextStep = function (exerciseMetaId, typeId, practiceIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var link;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOnceValue(this.commonService.getOnceValue(exerciseMetaId, typeId[this.stepIndex]))];
                    case 1:
                        if (_a.sent()) {
                            if (this.stepIndex == typeId.length - 1) {
                                link = ["case-practice-authorization-main", this.learningPathId, this.practiceId, this.practiceList[practiceIndex].id];
                                if (this.type) {
                                    this.router.navigate(link, { queryParams: { type: 'huatek' } });
                                }
                                else {
                                    this.router.navigate(link);
                                }
                            }
                        }
                        else {
                            this.stepIndex = typeId[this.stepIndex] % 700;
                            this.onGoToNextStep.emit(this.stepIndex);
                            return [2 /*return*/];
                        }
                        this.stepIndex++;
                        _a.label = 2;
                    case 2:
                        if (this.stepIndex < typeId.length) return [3 /*break*/, 0];
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CasePracticeAuthorizationListComponent.prototype.getOnceValue = function (value) {
        return this.commonService.getOnceIno(value).then(function (result) {
            return result;
        });
    };
    CasePracticeAuthorizationListComponent.prototype.close = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
        })
            .subscribe(function (result) {
            // 只在learningTour里出现，当完成能力是退出进入map
            if ((_this.finishStatus || !_this.finished) && _this.learningTour) {
                var link = ["learning-map", 3];
                _this.router.navigate(link);
            }
            else if (!_this.finishStatus && _this.finished && _this.learningTour) {
                _this.commonService.setOnceIno(_this.commonService.getOnceValue(_this.learningPathMetaId, 2)).subscribe(function () {
                    _this.router.navigate(["learning-map", 3]);
                });
            }
            else {
                var learningPathId_1 = null;
                var courseId_1 = null;
                _this.route.queryParams.subscribe(function (queryParams) {
                    learningPathId_1 = queryParams['learningPathId'];
                    courseId_1 = queryParams['courseId'];
                });
                if (learningPathId_1 && courseId_1) {
                    var link = ['course-new', learningPathId_1, courseId_1];
                    _this.router.navigate(link);
                }
                else {
                    var link = ["learning-path", _this.learningPathMetaId];
                    _this.router.navigate(link);
                }
            }
        });
    };
    CasePracticeAuthorizationListComponent.prototype.goToPostSurvey = function () {
        if (this.type === 'huatek') {
            this.commonService.sendPostMessage(1, 'goPostSurvey');
            return;
        }
        else {
            if (this.lock) {
                this.showToast();
                return;
            }
            this.apiService
                .ajax({
                type: "GET",
                url: "/sr/exposeoutapi/setAbilitySession/" +
                    this.learningPathMetaId +
                    "/4",
            })
                .subscribe(function (result) { });
            // let link = ["survey", this.learningPathId, 7, 1];
            // //新能力考核
            // if (this.version == 1) {
            //   link = ["ability-survey", this.learningPathMetaId, 2];
            // }
            var link = ["ability-survey", this.learningPathMetaId, 2];
            // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'情景模拟','btnName':this.approachTheme.btnTxt}).then();
            this.router.navigate(link);
        }
    };
    CasePracticeAuthorizationListComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    CasePracticeAuthorizationListComponent.prototype.finish = function () {
        if (this.finishStatus) {
            return;
        }
        else {
            this.commonService.setOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).subscribe();
            var link = ["learning-map"];
            this.router.navigate(link);
        }
    };
    CasePracticeAuthorizationListComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    return CasePracticeAuthorizationListComponent;
}());
export { CasePracticeAuthorizationListComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-list/case-practice-authorization-list.component.ts.pre-build-optimizer.js